import axios from "axios";

export const APISD = axios.create({
  baseURL: process.env.REACT_APP_SD,
});

export const setAuthToken = (token) => {
  if (token) {
    APISD.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete APISD.defaults.headers.commin["Authorization"];
  }
};
